module.exports = __webpack_public_path__ + "8bcfb9036502e344aeb2d9a8032e5712.ttf";